<template>
	<div class="main-view">
		<div style="margin-bottom: 10px;
					display: flex;
					flex-direction: row;
					align-items: center;">
			<!-- <span style="color: #FF8826;">1</span>-->
			<div style="font-size: 14px;
						width: 6px;
						height: 15px;
						background-color: #409eff;
						margin-right: 5px;
						border-radius: 4px;"></div> 
			<span style="margin-left: 0px;">{{ cardTitle }}（共{{  questionArr.length}}题）</span>
		</div>
		<div class="quetion-item" v-for="item,index in questionArr" :key="index"  :id="item.id">
			<div class="title-topic">
				<div class="label">
					{{item.text}}
				</div>
				<img style="width: 50%;" mode="aspectFit" alt="" :src="item.imageUrl" v-if="item.imageUrl != null"/>

				<audio
					class="aud"
					:ref="`${item.id}`"
					@play="onPlay(item)"
					@pause="onPause(item)"
					:src="item.audioUrl"
					controls="controls"
					style="width:70%;"
					v-if="item.audioUrl != null"
					>
				</audio>	
			</div>
			<div v-if="showAnswerFlagD" class="correctAnswer-view">正确答案：{{ item.correctAnswer.join('，') }}</div>
		</div>
	</div>
</template>

<script>
import GapFillingDrillApi from '@/api/src/drill/api/GapFillingDrillApi'
const gapFillingDrillApi = new GapFillingDrillApi()

export default {
	
	props:['showAnswerFlag','questionData','cardTitle'],
	data(){
		return{
			section:null,
			checkList: ['选中且禁用','复选框 A'],
			radio: 3,
			showAnswerFlagD:this.showAnswerFlag,
			questionDataArr:this.questionData,
			questionArr:[],
		}
	},
	mounted () {
		this.loadData()
	},
	watch:{
		
		showAnswerFlag(val){
			console.log("监听到变化")
			this.showAnswerFlagD = val
			this.$forceUpdate()
		},
	},
	methods:{
		radioChange(index,value){

		},
		async loadData(){
			let drillIds = this.questionDataArr.map(item => {return item.drillId})
			var body = {
				sessionTime: 0,
				idList: drillIds
			}
			var resp = await gapFillingDrillApi.getDrillList(body)
			console.log('----loadData---')
			console.log(resp)
			this.questionArr = resp
		},
		onPlay(item) {
			item.status = 'play';
			// console.log(this.$refs)
			for (let i = 0; i < this.questionArr.length; i++) {
				
				if (item.id != this.questionArr[i].id) {
					// 不是当前需播放的音频
					let id = this.questionArr[i].id;
					this.$refs[id][0].pause();
					console.log(this.$refs)
				} else {
					// 是当前需要播放的音频
				}
			}
		},

		/**
		 * 当音频暂停
		 */
		onPause(item) {
			item.status = 'pause';
		}
	}
}
</script>

<style lang="less" scoped>
	.main-view{
		margin: 10px;
		border-radius: 10px; /* 圆角半径10px */
		box-shadow: 0 0 10px rgba(132, 132, 132, 0.3); /* 添加阴影效果 */
		padding: 20px; /* 内边距 */
		width: 87%;
		padding-bottom: 0px;
	}

	.quetion-item{
		display: flex;
		flex-direction: column;
		margin-bottom: 0px;
		border-bottom: 2px solid #f1f1f1;
		margin-top: 10px;
		padding-bottom: 20px;
		.title-topic{
			font-size: 18px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			.label{

			}
		}
		.question-view{
			margin-top: 10px;
			margin-left: 20px;
		}
	}
	.correctAnswer-view{
	    margin: 20px;
		margin-top: 10px;
		color: green;
	}
	.aud{
		margin-top: 10px;
	}
</style>